<template>
  <div class="activity-detail-page">
    <div class="detail-cover-wrap">
      <img v-if="detailCover" :src="detailCover" alt="" class="detail-cover" />
      <button class="cover-btn left" @click="$router.go(-1)">
        <van-icon name="arrow-left" />
      </button>
      <button class="cover-btn right" @click="handleShare">
        <van-icon name="share-o" />
      </button>
    </div>

    <div class="detail-content">
      <div class="detail-card">
        <div class="detail-title-row">
          <h2 class="detail-title">{{ activityTitle }}</h2>
          <span class="detail-status" :class="statusClass">{{ statusText }}</span>
        </div>

        <div class="detail-period-card">
          <div class="period-item">
            <van-icon name="coupon-o" />
            <span>第{{ activityInfo.numberOfPeriods || "--" }}期活动</span>
          </div>
          <div class="period-item">
            <van-icon name="clock-o" />
            <span>{{ currentTimeRangeText }}</span>
          </div>
        </div>


        <div class="detail-section">
          <div class="section-title">活动信息</div>
          <div class="detail-info-list">
            <div class="detail-info-item" v-if="activityInfo.location">
              <span class="detail-info-label">活动地点</span>
              <span class="detail-info-value">{{ activityInfo.location }}</span>
            </div>
            <div class="detail-info-item" v-if="activityInfo.allSignUpCount || activityInfo.allSignUpCount === 0">
              <span class="detail-info-label">活动时间</span>
              <span class="detail-info-value">{{formatTimeRange(activityInfo.checkInStartTime, activityInfo.checkInEndTime)}}</span>
            </div>
            <!-- <div class="detail-info-item" v-if="activityInfo.prize">
              <span class="detail-info-label">活动礼品</span>
              <span class="detail-info-value">{{ activityInfo.prize }}</span>
            </div> -->
            <div class="detail-info-item" v-if="activityInfo.signUpQuota || activityInfo.signUpQuota === 0">
              <span class="detail-info-label">人数上限</span>
              <span class="detail-info-value">{{ activityInfo.signUpQuota }}</span>
            </div>
            <div class="detail-info-item" v-if="activityInfo.allSignUpCount || activityInfo.allSignUpCount === 0">
              <span class="detail-info-label">已报名人数</span>
              <span class="detail-info-value">{{ activityInfo.allSignUpCount }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section" v-if="activityInfo.introduction">
          <div class="section-title">活动简介</div>
          <div class="detail-introduction">{{ activityInfo.introduction }}</div>
        </div>

        <div class="detail-section">
          <div class="section-title">活动详情</div>
          <div class="detail-description" v-if="activityInfo.contentUrl">
            <img :src="activityInfo.contentUrl" alt="" class="detail-description-image" />
          </div>
        </div>
      </div>

      <div class="action-buttons" v-if="role === 'Member'">
        <!-- 活动期间按钮优先于报名时间：审核通过显示互选大厅 -->
        <template v-if="isInActivityPeriod">
          <div class="mutual-choice-btn" v-if="approvalStatus === 2" @click="goToMutualChoice">
            <van-icon name="friends-o" />
            <span>互选大厅</span>
          </div>

          <template v-if="approvalStatus === 2">
            <div class="signUp signUp-checked" v-if="isCheckedIn">
              <span class="checked-text">已签到</span>
            </div>

            <div class="signUp" :class="{ 'signUp-disabled': !canCheckIn }" @click="canCheckIn && handleCheckIn()"
              v-else-if="isInCheckInPeriod">
              签到
            </div>

            <div class="signUp signUp-disabled" v-else>
              报名成功
            </div>
          </template>

          <!-- 活动时间内且报名时间未结束、尚未报名：显示报名按钮（沿用原报名功能） -->
          <div class="signUp" :class="{ 'signUp-disabled': !canSignUp }" @click="canSignUp && handleSignUp()"
            v-if="!signedUpActivity && canSignUp && activityInfo.publishType === 1">
            我要报名
          </div>

          <!-- 活动时间内已报名待审核且报名时间未结束：可取消报名（沿用原取消功能） -->
          <div class="signUp" v-if="signedUpActivity && approvalStatus === 1 && canSignUp" @click="handleCancelSignUp">
            取消报名
          </div>

        </template>

        <!-- 非活动期间：报名期间显示我要报名/取消报名 -->
        <template v-else>
          <div class="signUp" :class="{ 'signUp-disabled': !canSignUp }" @click="canSignUp && handleSignUp()"
            v-if="!signedUpActivity && activityInfo.publishType === 1">
            {{ canSignUp ? '我要报名' : statusText === '已结束' ? '活动已结束' : '活动未开始' }}
          </div>

          <template v-if="signedUpActivity">
            <div class="signUp" v-if="approvalStatus === 1 && isInSignUpPeriod" @click="handleCancelSignUp">
              取消报名
            </div>

            <div class="signUp signUp-rejected" v-else-if="approvalStatus === 3">
              报名未通过
            </div>

            <div class="signUp signUp-disabled" v-else-if="approvalStatus === 2">
              报名成功
            </div>
          </template>
        </template>
      </div>
    </div>

        <div class="action-buttons" v-if="role === 'Matchmaker'">
          <div class="signUp" @click="showSignInList = true">
            查看签到
          </div>
          <div class="mutual-choice-btn" @click="showMutualChoiceList = true">
            <van-icon name="friends-o" />
            <span>互选记录</span>
          </div>
        </div>

    <van-overlay :show="shareGuideVisible" @click="shareGuideVisible = false">
      <div class="share-guide">
        <div class="share-guide-highlight" />
        <div class="share-guide-arrow">↗</div>
        <div class="share-guide-text">请点击右上角<br>分享给微信好友或朋友圈</div>
        <div class="share-guide-dismiss">轻触任意位置关闭</div>
      </div>


    </van-overlay>
        <van-popup v-model="showSignInList" position="bottom" :style="{ height: '70%' }" round>
          <div class="record-popup">
            <div class="record-popup-title">签到列表</div>
            <van-list v-model="signInLoading" :finished="signInFinished" @load="loadSignInList">
              <div v-for="(item, index) in signInList" :key="index" class="record-item">
                <div class="record-item-main">
                  <span class="record-item-name">{{ item.name || item.nickName || '未知' }}</span>
                  <span class="record-item-id">#{{ item.serialNumber || '--' }}</span>
                </div>
                <span class="record-item-status" :class="{ 'status-checked': item.checkInStatus === 1 }">{{ item.checkInStatus === 1 ? '已签到' : '未签到' }}</span>
              </div>
              <div v-if="signInList.length === 0 && !signInLoading" class="record-empty">暂无签到数据</div>
            </van-list>
          </div>
        </van-popup>

        <van-popup v-model="showMutualChoiceList" position="bottom" :style="{ height: '70%' }" round>
          <div class="record-popup">
            <div class="record-popup-title">互选记录</div>
            <div class="record-list">
              <div v-for="(item, index) in mutualChoiceList" :key="index" class="record-item">
                <div class="record-item-pair">
                  <span>{{ item.chooserName }}</span>
                  <van-icon name="like" />
                  <span>{{ item.selectedName }}</span>
                </div>
                <span class="record-item-status" :class="{ 'status-matched': item.matchStatus === 1 }">{{ item.matchStatusName }}</span>
              </div>
              <div v-if="mutualChoiceList.length === 0" class="record-empty">暂无互选记录</div>
            </div>
          </div>
        </van-popup>

  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import {
  getActivityInfoById,
  addActivityParticipants,
  checkUserSignedUp,
  checkIn,
  getWeChatJsSdkConfig,
    cancelActivityParticipants,
    getActivityParticipantsList,
    getMutualChoiceRecords
} from "../api/activityInfo";
import {
  isWeChatBrowser,
  buildActivityShareData,
  initWeChatShare,
  shareOrCopyLink
} from "../utils/wechatShare";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activityInfo: {},
      signedUpActivity: null,
      approvalStatus: null,
      isCheckedIn: false,
      sceneCode: "",
      shareGuideVisible: false,
      shareData: null,
      defaultCover: require("@/assets/defaultPhoto1.jpg"),
      showTimeDetail: false,
        showSignInList: false,
        showMutualChoiceList: false,
        signInList: [],
        signInLoading: false,
        signInFinished: false,
        signInPage: 1,
        mutualChoiceList: []
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "role"]),
    activityTitle() {
      return this.activityInfo.contentTitle || this.activityInfo.subject || "活动详情";
    },
    hasTimeDetail() {
      return !!(this.activityInfo.signUpStartTime || this.activityInfo.checkInStartTime || this.activityInfo.mutualChoiceStartTime);
    },
    detailCover() {
      return this.activityInfo.coverUrl || this.activityInfo.contentUrl || "";
    },
    isActivityEnded() {
      const endTime = this.activityInfo.endTime;
      if (!endTime) return false;
      const end = this.parseLocalTime(endTime); return end ? new Date() > end : false;
    },
    isActivityNotStarted() {
      // 活动尚未开始：当前时间早于活动开始时间、报名开始时间中的最早者
      const now = new Date();
      const times = [
        this.activityInfo.startTime,
        this.activityInfo.signUpStartTime,
        this.activityInfo.checkInStartTime,
        this.activityInfo.mutualChoiceStartTime
      ].filter(Boolean);
      if (times.length === 0) return false;
      return times.every(t => { const d = this.parseLocalTime(t); return d ? now < d : false; });
    },
        // 按报名/活动时间区间显示状态：未开始/报名中/进行中/已结束
    statusText() {
      const now = new Date();
      const signUpStart = this.parseLocalTime(this.activityInfo.signUpStartTime);
      const signUpEnd = this.parseLocalTime(this.activityInfo.signUpEndTime);
      const start = this.parseLocalTime(this.activityInfo.startTime);
      const end = this.parseLocalTime(this.activityInfo.endTime);
      // 进行中优先级大于报名中：活动期内即使仍在报名期也显示进行中
      if (start && end && now >= start && now <= end) return "进行中";
      if (signUpStart && now < signUpStart) return "未开始";
      if (signUpEnd && now <= signUpEnd) return "报名中";
      // 报名结束至活动开始之间：活动尚未开始
      if (start && now < start) return "未开始";
      return "已结束";
    },
statusClass() {
      switch (this.statusText) {
        case "未开始":
          return "status-upcoming";
        case "已结束":
          return "status-ended";
        case "签到中":
          return "status-checkin";
        case "互选中":
          return "status-mutual";
        case "报名中":
          return "status-signup";
        default:
          return "status-ongoing";
      }
    },
    isInSignUpPeriod() {
      return this.isInPeriod(this.activityInfo.signUpStartTime, this.activityInfo.signUpEndTime, this.activityInfo.endTime);
    },
    canSignUp() {
      return this.isInSignUpPeriod;
    },
    isInCheckInPeriod() {
      return this.isInPeriod(this.activityInfo.checkInStartTime, this.activityInfo.checkInEndTime, this.activityInfo.endTime);
    },
    canCheckIn() {
      return !this.isCheckedIn && this.isInCheckInPeriod;
    },
    isInMutualChoiceTime() {
      return this.isInPeriod(this.activityInfo.mutualChoiceStartTime, this.activityInfo.mutualChoiceEndTime, null);
    },
    isInActivityPeriod() {
      // 活动开始/结束时间 = checkInStartTime/checkInEndTime（与后台管理页字段一致）
      // 严格限定：当前时间必须处于活动开始时间~活动结束时间之间（起止时间缺失则不显示）
      const start = this.activityInfo.checkInStartTime ? this.parseLocalTime(this.activityInfo.checkInStartTime) : null;
      const end = this.activityInfo.checkInEndTime ? this.parseLocalTime(this.activityInfo.checkInEndTime) : null;
      if (!start || !end) return false;
      const now = new Date();
      return now >= start && now <= end;
    },
    canEnterMutualChoice() {
      // 活动期间且报名审核通过即可进入互选大厅（不再要求已签到/互选时段）
      return this.role === "Member" && this.approvalStatus === 2 && this.isInActivityPeriod;
    },
  currentTimeRangeText() {
      const status = this.statusText;
      const info = this.activityInfo;
      if (status === "互选中") {
        return `互选 ${this.formatDateTime(info.mutualChoiceStartTime)} - ${this.formatDateTime(info.mutualChoiceEndTime)}`;
      }
      if (status === "签到中") {
        return `签到 ${this.formatDateTime(info.checkInStartTime)} - ${this.formatDateTime(info.checkInEndTime)}`;
      }
      if (status === "报名中") {
        return `报名 ${this.formatDateTime(info.signUpStartTime)} - ${this.formatDateTime(info.signUpEndTime)}`;
      }
      if (info.signUpStartTime || info.signUpEndTime) {
        return `报名 ${this.formatDateTime(info.signUpStartTime)} - ${this.formatDateTime(info.signUpEndTime)}`;
      }
      return `签到 ${this.formatDateTime(info.checkInStartTime)} - ${this.formatDateTime(info.checkInEndTime)}`;
    }
  },
  methods: {
      // 解析后端返回的时间：去掉 Z 后缀，按本地时间解析，和后台设置的时间一致
      parseLocalTime(time) {
        if (!time) return null;
        let str = String(time);
        if (str.endsWith("Z")) str = str.slice(0, -1);
        if (str.endsWith("+00:00")) str = str.slice(0, -6);
        if (str.length === 10) str = str + "T00:00:00";
        const d = new Date(str);
        return isNaN(d.getTime()) ? null : d;
      },
      loadSignInList() {
        this.signInLoading = true;
        // 后端分页字段是 page/pageSize（ActivityParticipantsInputDto.Page），不是 pageIndex
        getActivityParticipantsList({
          activityInfoId: this.$route.params.id,
          checkInStatus: 1,
          page: this.signInPage,
          pageSize: 20
        }).then(res => {
          if (res.code === 20000 && res.data) {
            const items = res.data.items || [];
            this.signInList = this.signInList.concat(items);
            this.signInLoading = false;
            // 防御：返回空页或已取完则置 finished，避免 van-list 无限触发加载
            if (items.length === 0 || this.signInList.length >= (res.data.total || 0)) {
              this.signInFinished = true;
            } else {
              this.signInPage++;
            }
          } else {
            this.signInLoading = false;
            this.signInFinished = true;
          }
        }).catch(() => {
          this.signInLoading = false;
          this.signInFinished = true;
        });
      },
    loadMutualChoiceList() {
      getMutualChoiceRecords(this.$route.params.id).then(res => {
        if (res.code === 20000 && res.data) {
          this.mutualChoiceList = res.data || [];
        }
      }).catch(() => {});
    },
    formatTimeRange(startTime, endTime) {
      if (!startTime) return "";
      const start = this.formatTime(startTime);
      if (!endTime) return start;
      const end = this.formatTime(endTime);
      var startDate = this.GetTime(startTime);
      var endDate = this.GetTime(endTime);
      return `${startDate.year2}/${startDate.month}/${startDate.day} ${startDate.hour}:${startDate.minute} - ${endDate.year2}/${endDate.month}/${endDate.day} ${endDate.hour}:${endDate.minute}`;
      //return `${start} - ${end}`;
    },

    GetTime(time) {
      if (!time) return "";
      const date = this.parseLocalTime(time);
      const year = date.getFullYear();;
      const year2 = (year + '').substr(2);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      return { year, year2, month, day, hour, minute };
    },
    formatTime(time) {
      if (!time) return "";
      const date = this.parseLocalTime(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    formatDateTime(time) {
    if (!time) return "";
      const date = this.parseLocalTime(time);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      return `${month}-${day} ${hour}:${minute}`;
      },
    getOverdue(endTime) {
      if (!endTime) return false;
      const end = this.parseLocalTime(endTime); return end ? end > new Date() : false;
    },
    isInPeriod(startTime, endTime, fallbackEndTime) {
      const now = new Date();
      const start = startTime ? this.parseLocalTime(startTime) : null;
      const end = endTime ? this.parseLocalTime(endTime) : null;

      if (!start && !end) {
        return fallbackEndTime ? this.getOverdue(fallbackEndTime) : false;
      }

      if (start && now < start) return false;
      if (end && now > end) return false;
      return fallbackEndTime ? this.getOverdue(fallbackEndTime) : true;
    },
    async handleShare() {
      if (!this.shareData) {
        Toast.fail({ message: '活动信息未加载完成' });
        return;
      }

      if (isWeChatBrowser()) {
        this.shareGuideVisible = true;
        return;
      }

      const result = await shareOrCopyLink(this.shareData.link, this.shareData.title);
      if (result === 'copied') {
        Toast.success({ message: '链接已复制，请粘贴到微信中分享' });
      }
    },
    async initShareConfig() {
      if (!this.activityInfo || !this.activityInfo.id) return;
      this.shareData = buildActivityShareData(this.activityInfo);
      if (!isWeChatBrowser()) return;

      try {
        await initWeChatShare({
          ...this.shareData,
          getConfig: async () => {
            const currentUrl = window.location.href.split('#')[0];
            const res = await getWeChatJsSdkConfig(currentUrl);
            return res.data;
          }
        });
      } catch (error) {
        console.error('初始化微信分享失败:', error);
      }
    },
    handleSignUp() {
      Dialog.confirm({
        message: "是否确认报名"
      })
        .then(() => {
          const params = {
            memberInfoIdList: [this.baseInfo.id],
            activityInfoId: this.$route.params.id
          };
          addActivityParticipants(params).then(res => {
            if (res.code === 20000) {
              Toast.success({ message: "报名成功" });
              this.checkSignUpStatus();
            } else {
              Toast.fail({ message: res.message || res.msg || "报名失败" });
            }
          });
        })
        .catch(() => { });
    },
    handleCancelSignUp() {
      Dialog.confirm({
        message: "是否确认取消报名"
      })
        .then(() => {
          cancelActivityParticipants(this.$route.params.id, this.baseInfo.id).then(res => {
            if (res.code === 20000) {
              Toast.success({ message: "取消报名成功" });
              this.checkSignUpStatus();
            } else {
              Toast.fail({ message: res.message || "取消报名失败" });
            }
          });
        })
        .catch(() => { });
    },
    submitSignUp() {
      const params = {
        memberInfoIdList: [this.baseInfo.id],
        activityInfoId: this.$route.params.id,
      };
      addActivityParticipants(params).then((res) => {
        if (res.code === 20000) {
          Toast.success({ message: "报名成功" });
          this.checkSignUpStatus();
        } else {
          Toast.fail({ message: res.message || res.msg || "报名失败" });
        }
      });
    },
    handleCheckIn() {
      Dialog.confirm({
        message: "是否确认签到"
      })
        .then(() => {
          const params = {
            activityId: this.$route.params.id,
            memberId: this.baseInfo.id
          };
          checkIn(params).then(res => {
            if (res.code === 20000 && res.data) {
              if (res.data.success) {
                this.isCheckedIn = true;
                this.sceneCode = res.data.sceneCode;
                Toast.success({
                  message: res.data.message || "签到成功",
                  duration: 2000
                });
              } else {
                Toast.fail({
                  message: res.data.message || "签到失败",
                  duration: 2000
                });
              }
            } else {
              Toast.fail({ message: "签到失败" });
            }
          });
        })
        .catch(() => { });
    },
    checkSignUpStatus() {
      if (this.baseInfo && this.baseInfo.id) {
        checkUserSignedUp(this.$route.params.id, this.baseInfo.id).then(res => {
          if (res.code === 20000 && res.data) {
            const approvalStatus = res.data.approvalStatus !== undefined && res.data.approvalStatus !== null
              ? res.data.approvalStatus
              : (res.data.ApprovalStatus !== undefined && res.data.ApprovalStatus !== null ? res.data.ApprovalStatus : null);
            const checkInStatus = res.data.checkInStatus !== undefined && res.data.checkInStatus !== null
              ? res.data.checkInStatus
              : (res.data.CheckInStatus !== undefined && res.data.CheckInStatus !== null ? res.data.CheckInStatus : 0);
            const sceneCode = res.data.sceneCode !== undefined && res.data.sceneCode !== null
              ? res.data.sceneCode
              : (res.data.SceneCode !== undefined && res.data.SceneCode !== null ? res.data.SceneCode : "");
            this.signedUpActivity = res.data;
            this.approvalStatus = approvalStatus;
            this.isCheckedIn = checkInStatus === 1;
            this.sceneCode = sceneCode;
          } else {
            this.signedUpActivity = null;
            this.approvalStatus = null;
            this.isCheckedIn = false;
            this.sceneCode = "";
          }
        });
      }
      return Promise.resolve();
    },
    goToMutualChoice() {
      if (!this.isInMutualChoiceTime) {
        Toast.fail({ message: "当前不在互选时间内" });
        return;
      }
      if (this.approvalStatus !== 2) {
        Toast.fail({ message: "报名审核通过后才可进入互选大厅" });
        return;
      }
      if (!this.isCheckedIn) {
        Toast.fail({ message: "请先签到后再进入互选大厅" });
        return;
      }
      this.$router.push(`/mutualChoice/${this.$route.params.id}`);
    }
  },
  watch: {
    showMutualChoiceList(val) {
      if (val && this.mutualChoiceList.length === 0) {
        this.loadMutualChoiceList();
      }
    }
  },

  created() {
    getActivityInfoById(this.$route.params.id).then(res => {
      if (res.code === 20000) {
        this.activityInfo = res.data;
        this.initShareConfig();
      }
    });
    this.checkSignUpStatus();
  }
};
</script>
<style lang="less" scoped src="../style/socialActivities.less" />



// WEBPACK FOOTER //
// src/views/socialActivities.vue